import { useState, useEffect, useRef } from "react";
import Skeleton from "react-loading-skeleton";
import { NavLink } from "react-router-dom";
import "./Products.css";

const Products = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState([]);
  const [loading, setLoading] = useState(false);

  const componentMounted = useRef(true);

  useEffect(() => {
    const getProducts = async () => {
      setLoading(true);
      try {
        const response = await fetch("https://fakestoreapi.com/products");
        const productsData = await response.json();
        if (componentMounted.current) {
          setData(productsData);
          setFilter(productsData);
          setLoading(false);
        }
      } catch (error) {
        console.error("Failed to fetch products", error);
      }
    };

    getProducts();

    return () => {
      componentMounted.current = false;
    };
  }, []);

  const Loading = () => (
    <div className="products-grid">
      {Array(8)
        .fill()
        .map((_, index) => (
          <div key={index} className="skeleton-card">
            <Skeleton height={300} />
          </div>
        ))}
    </div>
  );

  const filterProducts = (cat) => {
    const updatedList = data.filter((x) => x.category === cat);
    setFilter(updatedList);
  };

  const ShowProducts = () => (
    <>
      <div className="filter-buttons">
        <button className="filter-btn" onClick={() => setFilter(data)}>
          All
        </button>
        <button className="filter-btn" onClick={() => filterProducts("men's clothing")}>
          Men's Clothing
        </button>
        <button className="filter-btn" onClick={() => filterProducts("women's clothing")}>
          Women's Clothing
        </button>
        <button className="filter-btn" onClick={() => filterProducts("jewelery")}>
          Jewelery
        </button>
        <button className="filter-btn" onClick={() => filterProducts("electronics")}>
          Electronics
        </button>
      </div>

      <div className="products-grid">
        {filter.map((product) => (
          <div className="product-card" key={product.id}>
            <div className="product-image">
              <img src={product.image} alt={product.title} />
            </div>
            <div className="product-info">
              <h5>{product.title.substring(0, 20)}...</h5>
              <p className="price">₹{product.price}</p>
              <NavLink className="buy-btn" to={`/products/${product.id}`}>
                Buy Now
              </NavLink>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <div className="products-container">
      <h1 className="section-title">Latest Products</h1>
      <hr className="divider" />
      {loading ? <Loading /> : <ShowProducts />}
    </div>
  );
};

export default Products;
